import axios from 'axios';
import { ENVIRONMENT, TAVUS_BASEURL } from 'shared/model';

import { getCookie } from 'shared/lib';

export const tavusHttpService = axios.create({
  baseURL: TAVUS_BASEURL,
  timeout: 60000
});

tavusHttpService.interceptors.request.use(
  (config) => {
    if (!config.headers.Authorization) {
      const token = getCookie(`${ENVIRONMENT}2_yepic_access_token`);
      if (token) {
        config.headers.Authorization = 'Bearer ' + token;
      }
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
